import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
//import EumPopover from 'eum-popover';
import { cache } from '@/util';

@Component({
    components: {},
})
export default class DisplayName extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String }) name!: string;
    @Prop({ type: String }) address!: string;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    // deptname: string = '';
    // jobtitle: string = '';

    avatar = {
        url: '',
        loading: false,
    };

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    // onPopchange(isOpen: boolean) {
    //     if (isOpen) {
    //         this.avatar.loading = true;
    //         cache.avatar.get(this.address).then((url) => {
    //             this.avatar.url = url;
    //             this.avatar.loading = false;
    //         });
    //         cache.hr.get(this.address).then((user: any) => {
    //             if (user) {
    //                 this.deptname = user.deptName;
    //                 this.jobtitle = user.titleName;
    //             } else {
    //                 cache.hr
    //                     .get(this.address.replace('dbins.dev', 'feelanet.com'))
    //                     .then((user: any) => {
    //                         if (user) {
    //                             this.deptname = user.deptName;
    //                             this.jobtitle = user.titleName;
    //                         }
    //                     });
    //             }
    //         });
    //     }
    // }
}
